import { render } from "./SketchDoodle.vue?vue&type=template&id=35cf0ab2"
import script from "./SketchDoodle.vue?vue&type=script&lang=js"
export * from "./SketchDoodle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__